namespace SPA
{
	export namespace Realtor
	{

		export class Display
			extends ui.base.BaseHTMLElement<HTMLDivElement>
		{

			private	m_List:			ui.base.BaseHTMLElement[];

			public constructor()
			{
				super( 'div' );

				this.Initialize(
					{
						classes: [ 'tab-content' ],
						css:
						{
							width: 'calc( 100% - 210px )'
						}
					}
				);

				this.m_List			= new Array();
			}

			public addPane( id: string ): ui.base.BaseHTMLElement// JQuery<HTMLDivElement>
			{
				const pane = new ui.base.BaseHTMLElement( 'div' );

				pane.addClass( 'tab-pane fade' ).attr(
					{
						role: 'tabpanel',
						id
					}
				);

				this.append( pane );

				this.m_List.push( pane );

				return pane;
			}

			public clear(): void
			{
				this.m_List	= new Array();
			}

			public rebuild( root: JQuery|ui.base.BaseHTMLElement ): void
			{
				this.appendTo( root );

				this.m_List.forEach( (pane) => pane.appendTo( this ) );
			}
		}

		/**
		 * IMPORTANT: Bitte diese addRegister verwenden, nicht addMenuItem!!!!
		 */
		export class Navigation
			extends SPA.Navigation.Navigation
		{

			private	m_Display:	Display;
			private	m_UUID:			string;
			private	m_Current:	JQuery|null;

			public constructor()
			{
				super();

				this.m_Display	= new Display();
				this.m_UUID			= ui.utils.UUID.Gen();

				this.m_UList.Initialize(
					{
						css:
						{
							"padding": '0',
							'padding-right': '2px',
							"width": '200px',
							'min-height': '200px'
						},
						attr:
						{
							role: 'tablist'
						}
					}
				);

				this.m_UList.addClass( 'nav nav-stacked box' );
				this.m_Current	= null;
			}

			public rebuild( root: ui.base.BaseHTMLElement|JQuery<HTMLElement> ): Navigation
			{
				super.rebuild( root );

				this.m_Display.rebuild( root );

				return this;
			}

			public addRegister( title: string, builder: ObjectDataBuilder<any>, active?: boolean ): void
			{
				const target = this.m_UUID + ui.utils.UUID.Gen();

				const reg = this.AddMenuPoint()
				.append(
					ui.$$.a()
						.text( title )
						.attr(
							{
								"href": '#' + target,
								'data-toggle': 'tab',
								"role": 'tab'
							}
						)
						.on( 'click', () => { this.m_Current = reg.Root().find( 'first-child' ); } )
				);

				reg.Initialize( { role: 'presentation' } );

				this.m_UList.append( reg );

				if ( this.m_List.length == 1 )
				{
					reg.addClass( 'active' );
					this.m_Current	= reg.Root().find( ':first-child' );
				}

				builder.rebuild( this.m_Display.addPane( target ).addClass( this.m_List.length == 1 ? 'in active' : '' ), this );

				if ( active )
				{
					this.m_Current	= reg.Root().find( ':nth-child(' + ( this.m_List.length - 1 ) + ')' );

					this.m_Current.tab( 'show' );
				}

				builder.afterBuild();
			}

			public clear(): void
			{
				this.m_List	= [];
				this.m_Display.clear();
			}

		}

	}
}
